import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { callAPI, createObject, IsSmallScreen, Method } from "../../../commonFunctions/CommonFunctions";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import SwipeableDrawerForm from "../../../Components/DrawyerForm/DrawyerForm";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { resetDataComponent, storeDataComponent, updateDataComponent } from "../../../StateManagement/actions";
import { EmailDrawyer } from "../../Emails/EmailDrawyer";
import { AllPermissions } from "../../../commonFunctions/PermissionManger";
import PermissionDenied from "../../../commonFunctions/PermissionDenied";

export const OverViewEmailContact: React.FC<any> = React.memo((props) => {
  AllPermissions.getInstance();
  const { add, edit, remove, view } = AllPermissions.getEmailPermission;
  const { showMessage } = useSnackbar();
  const dispatch = useDispatch()
  const params = useParams();
  const id = params?.id;
  const [open, setOpen] = React.useState(false);
  const [emailListData, setemaillistData] = useState<any>([])
  const [resetLoad, setResetLoad] = useState(false)
  const { control, register, handleSubmit, setValue, reset } = useForm();
  const [formComponent, setFormComponent] = useState<any>()
  const [loading, setLoading] = useState(false)

  const isMobile = IsSmallScreen();
  const resetTrigger = useSelector((state: any) => state.components?.emailContactDataGrid?.resetTrigger);
  useEffect(() => {

    const getEmails = async () => {
      try {
        setResetLoad(false)
        const response: any = await callAPI('email/lead', Method.GET, null, id)
        setemaillistData(response || []);
      }
      catch (e) {
      }
    }
    getEmails();
  }, [resetTrigger])

  useEffect(() => {

    const getEmails = async () => {
      try {
        setResetLoad(false)
        const response: any = await callAPI('email/lead', Method.GET, null, id)
        setemaillistData(response || []);
      }
      catch (e) {
      }
    }
    getEmails();
  }, [resetLoad])
  const handleEmail = async (data: any) => {
    try {

      if (data) {
        setLoading(true)
        dispatch(storeDataComponent('emailSubmit', { loading: true }));
        const response = await createObject('email/send', { toEmail: data?.toEmail, subject: data.subject, body: data.body, leadId: id })
        if (response && response?.message) {
          reset()
          dispatch(resetDataComponent('emailContactDataGrid'));
          showMessage(response?.message, response?.message?.includes('successfully') ? 'success' : 'error')
        } else if (response?.id) {

          showMessage('Mail sent successfully', 'success')
        }
      }
    }
    catch (e) { }
    finally {
      setLoading(false)
      dispatch(updateDataComponent('emailSubmit', { loading: false }));
    }
  }
  const columns: IColumns[] = [
    {
      header: "Subject",
      fieldName: "subject",
      tooltip: true,
      type: 'default'
    },
    {
      header: "To Email",
      fieldName: "toEmail",
      tooltip: true,
      type: 'default',
      isHide: isMobile
    },

    {
      header: "Send on",
      fieldName: "sentAt",
      tooltip: true,
      type: 'dateTime',
      isHide: isMobile
    },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [view ? "View" : undefined].filter(Boolean),
      actionCallback: (action, row) => handleAction(action, row),

    },
  ];

  const handleAction = async (action: string, row: any) => {
    if (action === "View") {
      const form: any = <EmailDrawyer
        id="emailAdd"
        data={row}
        emailId={row?.id}
        control={control}
        loading={loading}
        register={register}
        reset={reset}
        setValue={setValue}
        onCancel={() => { reset(); setOpen(false); setFormComponent(null) }}
      />
      setFormComponent(form)
      setTimeout(() => {
        setOpen(true)
      }, 10);

    }
  }
  const handleEmailsClick = () => {
    const form: any = <EmailDrawyer
      id="emailAdd"
      control={control}
      register={register}
      reset={reset}
      loading={loading}
      setValue={setValue}
      onCancel={() => { reset(); setOpen(false) }}
    />
    setFormComponent(form)
    setTimeout(() => {
      setOpen(true)
    }, 10);
  }

  return (
    <Grid    >
      <Grid container spacing={2} sx={{ p: 0, borderRadius: 5 }}>
        {view ? <Grid item xs={12}>
          <WSDataGrid
            id="emailContactDataGrid"
            title="Emails"
            data={emailListData}
             isAccordian={true}
            columns={columns}
            addButton={{ label: 'New', color: 'secondary', }}
            onAddButtonClick={handleEmailsClick}
         
          />
        </Grid>
          : <PermissionDenied />
          }
      </Grid>
      {formComponent && <SwipeableDrawerForm anchor="right" title={'Send Email'}
        openForm={open}
        formComponent={<form onSubmit={handleSubmit(handleEmail)}>
          {formComponent}
        </form>}
        onClose={() => { reset(); setOpen(false); setFormComponent(null) }}

      />}
      { }
    </Grid>
  );
});
